/** Sentry project: scrumlaunch-nj / sf-app (US). Override with NEXT_PUBLIC_SENTRY_DSN. */
export const SENTRY_DSN =
  process.env.NEXT_PUBLIC_SENTRY_DSN ??
  'https://a96381d66d94522a9f502f2437d5ae2b@o4510063760900096.ingest.us.sentry.io/4510084710400000';
